import React, { useEffect, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import BaseSidebar from '../../common/Sidebar/BaseSidebar.jsx';
import { useSidebarResize } from '../../common/Sidebar/useSidebarResize.js';
import WidgetSettingsSidebar from './WidgetSettingsSidebar.jsx';
import DashboardSidebar from './DashboardSidebar.jsx';
import { saveTheme, saveWidgetSettings, closeSidebar } from '../redux/dashboardSlice.js';
import { Button } from '../../bootstrap';

function SettingsSidebar({ editingId, width: initialWidth, setWidth }) {
    const dispatch = useDispatch();
    const { sidebarOpen, loading, error, configErrors, detailOpenId } = useSelector(state => state.dashboard);
    
    // You can use the hook here or pass these in from the parent
    const { width, handleMouseDown } = useSidebarResize(initialWidth);

    const handleSave = async () => {
        editingId ? await dispatch(saveWidgetSettings()) : await dispatch(saveTheme());
        if (Object.keys(configErrors).length === 0) dispatch(closeSidebar());
    };

    const footer = !detailOpenId && (
        <>
            <Button type='default' onClick={() => dispatch(closeSidebar())}>
                {I18n.t('close')}
            </Button>
            <Button type='primary' disabled={loading} onClick={handleSave}>
                {loading ? I18n.t('saving') : I18n.t('save')}
            </Button>
        </>
    );

    useEffect(() => {
        if (sidebarOpen) {
            setWidth(width);
        } else {
            setWidth(0);
        }
    }, [width, sidebarOpen]);

    return (
        <BaseSidebar
            isOpen={sidebarOpen}
            width={width}
            onResizeStart={handleMouseDown}
            onClose={() => dispatch(closeSidebar())}
            footerActions={footer}
        >
            {error && <p className='text-danger'>Backend error: {error}</p>}
            {editingId ? <WidgetSettingsSidebar editingId={editingId} /> : <DashboardSidebar />}
        </BaseSidebar>
    );
}

export default memo(SettingsSidebar);
